import { render, staticRenderFns } from "./PartyDetailsPaymentsTab.vue?vue&type=template&id=490a47b4"
import script from "./PartyDetailsPaymentsTab.vue?vue&type=script&lang=js"
export * from "./PartyDetailsPaymentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports